
import Vue from "vue"
import { mapGetters } from "vuex"

export default Vue.extend({
  // validate ({ store }) { return store.getters["user/isAdmin"] },

  data: () => ({
    title: "Аллея технологического лидерства",
    partnersEmail: "partners@rif.ru",
  }),

  head () {
    return { title: this.getTitle(this.title) }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
})
